module.exports = __webpack_public_path__ + "img/logo.d4fd5cca.png";